import { REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const contactAdvisorValidation = (errors) =>
  yup.object().shape({
    lastname: yup.string().required(errors.REQUIRED),
    firstname: yup.string().required(errors.REQUIRED),
    phone: yup
      .string()
      .nullable()
      .test("phone", errors.INVALID_VALUE, (value) => {
        if (!value) return true;
        const normalized = String(value).replace(/\s+/g, "");
        return new RegExp(REGEX_EXPS.phone).test(normalized);
      }),
    email: yup.string().required(errors.REQUIRED).email(errors.INVALID_VALUE),
    memberNumber: yup.string().required(errors.REQUIRED),
    acceptEmailSms: yup.boolean(),
    acceptPhone: yup.boolean(),
  });

export default contactAdvisorValidation;
